import { createContext, useContext, useEffect, useState } from 'react'
import { useAdminApi } from '../admin/api'

export type Lang = 'eu' | 'es'

interface LangState {
  lang: Lang
  changeLang: (next: Lang) => Promise<void>
}

// G-C5: idioma = preferencia por usuario (persistida), euskera por defecto.
const LangContext = createContext<LangState>({ lang: 'eu', changeLang: async () => {} })

export function LangProvider({ children }: { children: React.ReactNode }) {
  const api = useAdminApi()
  const [lang, setLang] = useState<Lang>('eu')

  useEffect(() => {
    api
      .get('/auth/me')
      .then((me: { idioma?: Lang }) => {
        if (me?.idioma) setLang(me.idioma)
      })
      .catch(() => {})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function changeLang(next: Lang) {
    setLang(next)
    await api.patch('/auth/me/idioma', { idioma: next })
  }

  return <LangContext.Provider value={{ lang, changeLang }}>{children}</LangContext.Provider>
}

export function useLang(): Lang {
  return useContext(LangContext).lang
}

export function LangSelect({ className }: { className?: string }) {
  const { lang, changeLang } = useContext(LangContext)
  return (
    <select
      className={className}
      aria-label="Hizkuntza / Idioma"
      value={lang}
      onChange={(e) => changeLang(e.target.value as Lang)}
    >
      <option value="eu">EU</option>
      <option value="es">ES</option>
    </select>
  )
}
